<template>
  <div>
    <common-list
      ref="list"
      url="TimeRule/GetList"
      @currentrow="handlerCurrentRow"
    >
      <template v-slot:filter="{ filter }">
        <el-form-item label="规则名称" prop="TimeruleName">
          <el-input
            v-model.trim="filter.TimeruleName"
            placeholder="规则名称"
            clearable
          ></el-input>
        </el-form-item>
      </template>
      <template v-slot:option>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="add"
          v-if="auth('TimeRuleAdd')"
          >添加</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-edit"
          @click="edit"
          v-if="auth('TimeRuleEdit')"
          >编辑</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          @click="deleteItem"
          v-if="
            auth('TimeRuleDelete') && currentrow && currentrow.IsDefault != '1'
          "
          >删除</el-button
        >
        <el-button
          type="success"
          @click="setDef"
          v-if="
            auth('SetTimeRuleDef') && currentrow && currentrow.IsDefault != '1'
          "
          >设为默认</el-button
        >
      </template>
      <template v-slot:body>
        <el-table-column
          label="规则名称"
          prop="TimeruleName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="规则描述"
          prop="Remark"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="允许时间段" show-overflow-tooltip>
          <template v-slot="{ row }">
            <span>{{ getTimeFormat(row.AllowTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否默认">
          <template v-slot="{ row }">
            <span>{{ row.IsDefault == "1" ? "是" : "否" }}</span>
          </template>
        </el-table-column>
      </template>
    </common-list>
    <add-edit
      ref="addedit"
      @success="getData"
      :item="aeitem"
      title="时间规则"
      getUrl="TimeRule/GetTimeRuleByID"
      addUrl="TimeRule/Add"
      editUrl="TimeRule/Edit"
      width="500px"
      labelWidth="120px"
    >
      <template v-slot="{ form }">
        <el-form-item
          label="规则名称"
          prop="TimeruleName"
          :rules="[$g.validRequired, $g.validLen(32)]"
        >
          <el-input
            v-model.trim="form.TimeruleName"
            placeholder="规则名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="规则描述" prop="Remark" :rules="$g.validLen(32)">
          <el-input
            v-model.trim="form.Remark"
            placeholder="规则描述"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="允许时间段"
          prop="AllowTime"
          :rules="$g.validRequired"
        >
          <AllowTime v-model.trim="form.AllowTime"></AllowTime>
        </el-form-item>
      </template>
    </add-edit>
  </div>
</template>

<script>
import AllowTime from "./AllowTime.vue";
export default {
  components: {
    AllowTime,
  },
  data() {
    return {
      aeitem: {},
    };
  },
  mounted() {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    add() {
      this.$refs.addedit.type = "add";
      this.aeitem = {};
    },
    edit() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$refs.addedit.type = "edit";
      this.aeitem = { TimeruleId: this.currentrow.TimeruleId };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$confirm(
        `将删除规则名称为【${this.currentrow.TimeruleName}】的规则, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("TimeRule/Delete", {
            TimeruleId: this.currentrow.TimeruleId,
          }).then(() => {
            this.$refs.list.getTableData();
          });
        })
        .catch(() => {});
    },
    getTimeFormat(str) {
      let res = [];
      if (str) {
        try {
          let list = JSON.parse(str);
          list.forEach((item) => {
            if (item && item.length == 2) {
              let e = `${item[0]}至${item[1]}`;
              res.push(e);
            }
          });
        } catch {
          console.log(str);
        }
      }
      return res.join(";");
    },
    setDef() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$put("TimeRule/SetIsDefault", {
        TimeruleId: this.currentrow.TimeruleId,
      }).then((r) => {
        this.$message.success("设置成功");
        this.$refs.list.getTableData();
      });
    },
  },
};
</script>

<style>
</style>